import React from 'react';
import { Tag } from 'core/components';
import { isPastDate } from 'core/util/dateUtils';

const ProductLabel = ({ text, isDarkMode, isUpdated, isBeta, isNew, isPreview, expiryDate, ...rest }) => {
  if (expiryDate && isPastDate(expiryDate)) {
    return null;
  }

  if (isUpdated) {
    return (
      <>
        {' '}
        <Tag className="product-meta updated" intent="warning" {...rest}>
          Updated
        </Tag>
      </>
    );
  }

  if (isBeta) {
    return (
      <>
        {' '}
        <Tag className="product-meta beta" intent="success" {...rest}>
          Beta
        </Tag>
      </>
    );
  }
  if (isNew) {
    return (
      <>
        {' '}
        <Tag className="product-meta new" intent="warning" {...rest}>
          New
        </Tag>
      </>
    );
  }

  if (isPreview) {
    return (
      <>
        {' '}
        <Tag className="product-meta preview" intent="success" {...rest}>
          Preview
        </Tag>
      </>
    );
  }

  return null;
};

export default ProductLabel;
